/**
 * État de connectivité — source unique.
 *
 * On s'appuie sur l'`onlineManager` de TanStack Query (déjà à l'écoute des
 * évènements navigateur `online`/`offline`) plutôt que d'ouvrir une seconde
 * détection. C'est LUI qui, en phase file de mutations, met les écritures en
 * pause hors ligne et les reprend au retour du réseau : garder une source
 * unique garantit que le bandeau UI et le comportement des mutations sont
 * toujours cohérents.
 */
import { onlineManager } from "@tanstack/react-query";
import { useSyncExternalStore } from "react";

/** `true` tant que le navigateur se considère en ligne. */
export function useIsOnline(): boolean {
  return useSyncExternalStore(
    (onChange) => onlineManager.subscribe(() => onChange()),
    () => onlineManager.isOnline(),
    () => true, // SSR / rendu initial : on suppose en ligne.
  );
}
